import React from 'react';

import { List } from '@buildoutinc/blueprint-react/ui/List';
import { Popover } from '@buildoutinc/blueprint-react/ui/Popover';

import { Button } from 'components/ui/button';

import type { PageUsage } from './types';

interface Props {
  documents: PageUsage[];
  documentsCount: number;
}

const positionLabel = (usage: PageUsage) => {
  if (usage.lastPage) return 'Last page';
  if (usage.position) return `Page ${usage.position}`;

  return 'In library';
};

export default function UsedInPopover({ documents, documentsCount }: Props) {
  return (
    <Popover>
      <Popover.Trigger className="btn btn-link p-0 clickable text-decoration-underline">
        {documentsCount} {documentsCount === 1 ? 'document' : 'documents'}
      </Popover.Trigger>
      <Popover.Content align="start" side="bottom" style={{ minWidth: 280, maxWidth: 360 }}>
        <Popover.Body>
          <List flush>
            {documents.map(usage => (
              <List.Item key={`${usage.documentTemplateId}-${usage.contextType}-${usage.contextId}`}>
                <List.ItemContent className="d-flex justify-content-between align-items-baseline gap-3">
                  <span className="text-truncate">{usage.documentTemplateName}</span>
                  <span className="text-muted text-nowrap">{positionLabel(usage)}</span>
                </List.ItemContent>
              </List.Item>
            ))}
          </List>
          {/* Shell link: the page detail view ships with BSD-37518. */}
          <div className="mt-2">
            <Button disabled size="sm" title="Coming soon" variant="secondary">
              Manage where this page is used
            </Button>
          </div>
        </Popover.Body>
      </Popover.Content>
    </Popover>
  );
}
